(function($, undefined) {
	
	'use strict';
	var currPage;
	var claimPaymentBtn;
    
  var claimPayment = function(){
    var t = $(this);
    var ctn = t.closest(".claim-payment-popup");
    var input = ctn.find(".claim-amt-payment");
    var amt = input.val();
    var limit = input.attr("max");
    var limitExceededError = $('.js-form-error-message.requested-amount-excedes-balance', ctn);
    var zeroOrUnderError = $('.js-form-error-message.requested-amount-zero-or-under', ctn);

    formValidator.validateForm(ctn);

    if (!ctn.hasClass('has-error')) {
        t.addClass("disabled");
        
        if (parseFloat(amt) <= 0) {
            t.removeClass("disabled");
            zeroOrUnderError.slideDown();
        } else {
            if (parseFloat(amt) <= parseFloat(limit)) {
                limitExceededError.slideUp();
                zeroOrUnderError.slideUp();
                var url = "/action/epAddAlert";
                url += "?ajax=true";
                url += "&amt="+amt;
                
                
                ajax(url, function(){
                    ctn.find(".request-success").slideDown();
                    window.setTimeout(function(){
                        location.reload();
                    }, 1500);
                    
                },true);
            } else {
                t.removeClass("disabled");
                limitExceededError.slideDown();
            }
        }
    }
  };
    
	var init = function (page) {
		currPage = $(page);
        
        
        claimPaymentBtn = $(".claim-payment-confirm-btn");
        claimPaymentBtn.on("click",claimPayment);
	};
	
    
    
   	
	$(window).on("load",function(){
        init();
    });
	
})(jQuery);